import React, { useState, useEffect } from 'react';
import * as utils from '../../../common/utils'
// import {
//     TableauViz,
//     TableauEventType,
// } from 'https://tableau.honeywell.com/javascripts/api/tableau.embedding.3.latest.min.js';
import {
    TableauViz,
    TableauEventType,
} from '../../../common/tableau';

export default ({ data, refresh }) => {

    const [tableauData, setTableauData] = useState(data)
    const basePath = utils.getBasePath()

    useEffect(() => {

        const script = document.createElement("script");
        script.src = basePath + '/js/tableua_viz_v1.js'
        script.async = true;
        document.body.appendChild(script);


        setTableauData(data);
        return () => {
            document.body.removeChild(script);
        }

    }, [data])


    const addTableuScript = () => {

        const script = document.createElement("script");

        script.src = "https://tableau.honeywell.com/javascripts/api/viz_v1.js";
        script.async = true;
        document.body.appendChild(script);
    }

    const getTableauTpl = () => {
        return <div
            dangerouslySetInnerHTML={{
                __html: `${tableauData}`
            }}></div>
    }

    return (
        <>


            {tableauData && getTableauTpl()}

        </>
    )
}